import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { AuthUserService } from '@src/app/modules/auth';
import { EnvService } from '@src/app/modules/env';

import { MessageModel } from '../types';
import { MessageService } from '../services';
import { StoreService } from '../../services';
import { ChatPermissionsModel } from '../../chat';

import { MAX_WIDTH_MESSAGE_DESKTOP, MAX_WIDTH_MESSAGE_MOBILE } from './constants';

@Component({
  selector: 'message-wrapper',
  templateUrl: './message-wrapper.component.html',
  styleUrls: ['./message-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MessageWrapperComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly authUserService = inject(AuthUserService);
  private readonly store = inject(StoreService);
  private readonly messageService = inject(MessageService);
  private readonly env = inject(EnvService);

  @Input() message!: MessageModel;
  @Input() permissions?: ChatPermissionsModel | null;

  isSelf = false;
  isReading = false;

  readonly maxWidth = this.env.isMobilePlatform ? MAX_WIDTH_MESSAGE_MOBILE : MAX_WIDTH_MESSAGE_DESKTOP;

  get replyMessage() {
    return this.message.replyMessageId ? this.store.getMessage(this.message.replyMessageId) : undefined;
  }

  ngOnInit(): void {
    this.isSelf = this.authUserService.authUser$.value?.id === this.message.userId;
    this.isReading = this.authUserService.authUser$.value?.id === this.message.userId;
    this.cdr.markForCheck();
  }

  sendReaction(emodjiName: string, message: MessageModel) {
    this.messageService.sendReaction(message.chatId, message.id, emodjiName).subscribe();
  }
}
